import { CustomTable } from './components/customTable';
import { TextAlign, FixedDirection } from './interface';

export {
    CustomTable,
    TextAlign,
    FixedDirection,
};
